import { ContextWindow } from "@asup/context-menu";
import { AnalysisMethodControl, GroupingFactorControl, OperationControl } from "../components";
import { useArsTable } from "./ArsTableContextProvider";
import { ArsTableItemParameters } from "./ArsTableItemParameters";
import { ARST_SET_VIEW_ITEM } from "./interface";

/**
 * Placeholder panel that shows the currently selected ArsTable item type and id.
 *
 * @returns Offcanvas with selected item details, or null when no item is selected
 */
export const ArsTableItemProperties = <T,>(): React.ReactNode => {
  const { state, dispatch } = useArsTable<T>();
  if (!state?.viewItem) {
    return null;
  }

  /**
   * Clears the current view item and closes the properties panel.
   */
  const handleHide = (): void => {
    dispatch({ operation: ARST_SET_VIEW_ITEM, viewItem: undefined });
  };

  return (
    <ContextWindow
      id={"ars-table-item-properties"}
      visible={state.viewItem !== undefined}
      onClose={handleHide}
      initialDockEdge="left"
      title="Item properties"
    >
      {state.viewItem.type === "analysisMethod" ? (
        <>
          <AnalysisMethodControl
            dataPath={`/analysisMethods/${state.viewItem.id}`}
            disabled
          />
          <ArsTableItemParameters dataPath={state.viewItem.dataPath} />
        </>
      ) : state.viewItem.type === "operation" ? (
        <>
          <OperationControl
            dataPath={`/operations/${state.viewItem.id}`}
            siblingCount={-9}
            disabled
          />
          <ArsTableItemParameters dataPath={state.viewItem.dataPath} />
        </>
      ) : state.viewItem.type === "groupingFactor" ? (
        <>
          <GroupingFactorControl
            dataPath={`/groupingFactors/${state.viewItem.id}`}
            disabled
          />
          <ArsTableItemParameters dataPath={state.viewItem.dataPath} />
        </>
      ) : (
        <div className="text-danger">Invalid item type</div>
      )}
    </ContextWindow>
  );
};

ArsTableItemProperties.displayName = "ArsTableItemProperties";
